module.exports = __webpack_public_path__ + "img/mco.b4f4b90d.svg";